import { validateCtc } from "../../../../../utils/ctc";

const validate = (name,value,formData)=>{
    let error = {status:false,message:''}
    let isField = schema[name];
 
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    // const mobileRegex = /^\d{10}$/;


    const fieldNames = {
    first_name:'First Name',
    last_name:'Last Name',
    gender:'Gender',
    email_id:'Email ID',
    dob:'DOB',
    mobile_no:'Contact No',
    referral_type:'Source',
    job_title:'Job Title',
    applied_date:'Applied Date',
    hr:'hr',
    ctc:'CTC',
    ectc:'Expected CTC',
    };


    if(isField){
        let validation = isField;
        for(let i=0;i<validation.length;i++){
            switch(validation[i]){
                case 'required':
                if(formData[name]==''){
                    error = {status:true,message:`${fieldNames[name]} is required`};
                    return error;
                }
                break;
                case 'dropdown':
                    if(formData[name]?.value==''){
                        error = {status:true,message:`This field is required`};
                        return error;
                    }
                    break;
                case 'email':
                    if((!emailRegex.test(value))){
                        error = {status:true,message:`Valid email is required`}
                        return error;
                    }
                break;
                case 'mobile_no':
                    if(formData[name]==''){
                        error = {status:true,message:`Valid mobile no is required`}
                        return error;
                    }
                break;
                case 'ctc':
                    error = validateCtc(formData[name],fieldNames[name]);
                    if(error.status){
                        return error;
                    }
                break;
            }
        }
    }
    return error;
}
const schema = {
    first_name:['required'],
    last_name:['required'],
    gender:['required'],
    email_id:['required','email'],
    dob:['required'],
    mobile_no:['required','mobile_no'],
    referral_type:['required','dropdown'],
    job_title:['required'],
    applied_date:['required'],
    hr:['required'],
    ctc:['required','ctc'],
    ectc:['required','ctc'],
}
export default validate;
